import React from 'react'
import ClipLoader from "react-spinners/ClipLoader"

const Loader = () => {
    return (
        <div className="loader-page">
            <ClipLoader 
                color={'#2098de'} 
                loading={true} 
                size={60} />
        </div>
    )
}

export default Loader
